export enum PaymentUploadTypeEnum {
  PAYMENT_SLIP = 'PAYMENT_SLIP',
}
